import * as request from '../utils/request'

export function get(param) {
    return request.post('config.dict.get', '1.0.0.0', param)
}
